var _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgIconGameRules = function SvgIconGameRules(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 22 22"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFE9A8",
    d: "M16.042 1.833H5.958a2.29 2.29 0 0 0-2.291 2.292v13.75a2.29 2.29 0 0 0 2.291 2.292h10.084a2.29 2.29 0 0 0 2.291-2.292V4.125a2.29 2.29 0 0 0-2.291-2.292"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    d: "M7.333 6.875h7.334Zm0 4.125h7.334Zm0 4.125h4.584Z"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#330E07",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M7.333 6.875h7.334M7.333 11h7.334m-7.334 4.125h4.584"
  })));
};
export default SvgIconGameRules;